// Feature Constants

// Miscellaneous
export const BILLINGANDPAYMENT = 'Global_Feature_BILLINGANDPAYMENT_Enabled_ForDealerCode';
export const VIEWCONTRACTDETAILS = 'Global_Feature_VIEWCONTRACTDETAILS_Enabled_ForDealerCode';


// Perks
export const PERKSGROUP = 'Global_GroupFeature_Perks_Enabled_ForDealerCode';
export const PGID = 'Global_Feature_PGID_Enabled_ForDealerCode';
export const WIFISPEEDCHECK = 'Global_Feature_WIFISPEEDCHECK_Enabled_ForDealerCode';

// Claims
export const CLAIMSGROUP = 'Global_GroupFeature_Claims_Enabled_ForDealerCode';
export const FILEACLAIM = 'Global_Feature_FILEACLAIM_Enabled_ForDealerCode';
export const CLAIMSHISTORYANDSTATUS = 'Global_Feature_CLAIMSHISTORYANDSTATUS_Enabled_ForDealerCode';

export const CLAIMSANDSUPPORTURL = '/device-select'
export const VIEWCLAIMSTATUS = 'action_view_claim_status';
export const VIEWTUTORIALS = 'action_view_tutorials';

// Chat
export const CHATGROUP = 'Global_GroupFeature_Chat_Enabled_ForDealerCode';
export const CHAT = 'Global_Feature_CHAT_Enabled_ForDealerCode';
export const CHATHISTORY = 'Global_Feature_CHATHISTORY_Enabled_ForDealerCode';

// Tech Services
export const TECHSERVICES = 'Global_Feature_TECHSERVICES_Enabled_ForDealerCode';

// Tech Special Offers
export const TECHGROUP = 'Global_GroupFeature_Tech_Enabled_ForDealerCode';

// Url auth guard
export const TECHSERVICEURLNAME = 'tech-services';
export const WIFIPERKURLNAME = 'speedtest';
export const PGIDPERKURLNAME = 'manage-your-identity';
export const PROFILEURLNAME = 'action_profile';
export const CLAIMSSUPPORTURLNAME = 'action_claims_support';
export const COVERAGEURLNAME = 'action_coverage';
export const PROGRAMINFORMATION = '^program_information';
export const LANGUAGES = 'languages';
// URL Code
export const HELLOTECHURLCODE = 'helloTechUrl';
export const PTPSCHEDULINGURLCODE = 'ptpSchedulingUrl';
export const LOGOUT = 'logout';
//export const CHANGEPASSWORD = 'change-password';

// Action Type
export const REDIRECTACTIONTYPE = 'redirect';

// DTE Id
export const DTEID = '7c00005f-859f-4891-b959-256128098790';
